export const MODULE_SURGICALLOGS = 'SURGICALLOGS'
export const MODULE_CREDENTIALING = 'CREDENTIALING'
export const MODULE_TRACKING = 'TRACKING'
export const OLD_MODULE_TRACKING = 'STERILIZERS'
export const MODULE_DOCUMENTS = 'DOCUMENTS'
export const MODULE_STANDARDS = 'STANDARDS'
export const MODULE_POLICIES = 'POLICIES'
export const MODULE_CONTRACTS = 'CONTRACTS'
export const MODULE_COMPLIANCE_ASSISTANT = 'COMPLIANCE_ASSISTANT'
